import { Component, computed, input } from "@angular/core";
import { EstatePorpertiesHelper } from "./properties-helper";

export interface IEstateProperty {
    heading: string;
    value: string | number;
    notation: string;
    position?: "left" | "right" | "none";
}

@Component({
    selector: "mini-infocard-realestate-properties",
    templateUrl: "./mini-infocard-realestate-properties.html",
    styleUrl: "./mini-infocard-realestate-properties.scss",
    standalone: true,
})
export class MiniInfoCardRealEstatePropertiesComponent {
    keyInfo = input(undefined);

    estateProperties = computed((): IEstateProperty[] => {
        if (!this.keyInfo()) return [];
        return EstatePorpertiesHelper.getEstateProperties(this.keyInfo());
    });
}
